import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useTheme
} from "@mui/material";
import { LeafIcon } from "@qubit/autoparts";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "~/app/store";
import {
  addSanitizedBin,
  closeSanitizeModal,
  selectRow
} from "~/features/autostorePutaway/autostorePutaway.slice";
import { AlertInfo } from "~/features/inventory/components/AlertInfo";
import { mixpanelTrack, useMixpanelPageName } from "~/lib/mixpanel-tracking";

type Props = {
  onConfirm?: () => void;
  binNumber: number;
};

export function SanitizeModal({ onConfirm, binNumber }: Props) {
  const { t } = useTranslation();
  const trackedPageName = useMixpanelPageName();
  const dispatch = useAppDispatch();
  const palette = useTheme().palette;
  const isSanitizeModalOpen = useAppSelector(
    (state) => state.autostorePutaway.isSanitizeModalOpen
  );

  const alertMessage = t("this item requires a sanitized bin");

  return (
    <Dialog
      open={isSanitizeModalOpen}
      maxWidth="sm"
      onClose={() => {
        dispatch(selectRow(null));
        dispatch(closeSanitizeModal());
      }}
    >
      <DialogTitle>{t("wipe bin")}</DialogTitle>
      <DialogContent sx={{ margin: "30px 30px 0" }}>
        <AlertInfo
          message={alertMessage}
          type="sanitize"
          icon={<LeafIcon sx={{ color: palette.infoPurple.dark }} />}
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", p: 3 }}>
        <Button
          size="large"
          onClick={() => {
            mixpanelTrack({
              type: "Button Click",
              label: "Confirm",
              trackedPageName,
              eventProperties: {
                from: "Sanitize Modal"
              }
            });
            dispatch(addSanitizedBin(binNumber));
            dispatch(closeSanitizeModal());
            onConfirm?.();
          }}
        >
          {t("confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
